import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import Banner1 from "../../assets/images/dasboard/banner1.png";
import Watchlinked from "../../assets/images/dasboard/watchlinked.png";
import errorlink from "../../assets/images/linker/errorlink.png";
import unlink from "../../assets/images/linker/unlink.png";
import link from "../../assets/images/linker/link.png";
import link1 from "../../assets/images/linker/link1.png";
import link2 from "../../assets/images/linker/link2.png";
import link3 from "../../assets/images/linker/link3.png";
import link4 from "../../assets/images/linker/link4.png";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import {
  LinkedFitBit,
  LinkedGoogleFit,
  UnLinkedGoogleFit,
} from "../../function/functions";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { DASHBOARDENDPOINT } from "../../config/ApisCollection";

const menuOptionData = [
  // {
  //   name: "Apple health",
  //   key: 1,
  //   subtitle: "Link the FastBetter app with apple health",
  //   src: link2,
  //   isLinked: false,
  //   device: "apple",
  // },
  {
    name: "Health Connect",
    key: 2,
    subtitle: "Link the FastBetter app with health connect",
    src: link1,
    isLinked: false,
    device: "googlehealth",
  },
  {
    name: "Fitbit",
    key: 3,
    subtitle: "Link the FastBetter app with fitbit",
    src: link3,
    isLinked: false,
    device: "fitbit",
  },
  // {
  //   name: "Google Fit",
  //   key: 4,
  //   subtitle: "Link the FastBetter app with health connect",
  //   src: link4,
  //   isLinked: false,
  //   device: "googlehealth",
  // },
];

export default function Menu() {
  const dispatch = useDispatch();
  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(31));
  };
  const handleLink = async (key) => {
    setDeviceKey(key);
    setIsPopupOpen(true);
  };
  const hanldeClose = async () => {
    setDeviceKey(null);
    setIsPopupOpen(false);
  };
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [deviceKey, setDeviceKey] = useState(null);
  const [menuOption, setMenuOption] = useState(menuOptionData || []);
  const [activeDevice, setActiveDevice] = useState(null);

  const handleLinkedDevice = async (device) => {
    try {
      if (device === "googlehealth") {
        const result = await LinkedGoogleFit();
        window.location.href = result?.url;
      } else if (device === "fitbit") {
        const result = await LinkedFitBit();
        window.location.href = result?.url;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUnLinkedDevice = async (device) => {
    try {
      if (device === "googlehealth") {
        const result = await UnLinkedGoogleFit();
        window.location.href = result?.url;
      } else if (device === "fitbit") {
        const result = await UnLinkedGoogleFit();
        window.location.href = result?.url;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetLinkedDeviceByDasbhoard = async () => {
    const accessToken = secureLocalStorage.getItem("accessToken");
    const get_body = {};
    const get_headers = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.get(DASHBOARDENDPOINT, get_headers);
      setActiveDevice(response.data.healthDevice);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetLinkedDeviceByDasbhoard();
  }, []);
  // console.log(activeDevice?.status);
  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack
          className="bg-transparent"
          handleCloseDrawer={handleCloseDrawer}
        />
      </div>
      <div className="flex flex-col gap-2 mt-12 w-10/12 mx-auto pb-14">
        <div className="cardbox w-full border-none mb-6 border-gray-200 shadow-md">
          <div className="mode1">
            <img
              className="watchImg w-32 h-32"
              alt="watchImg"
              src={activeDevice?.status === "active" ? Watchlinked : Banner1}
            />
            <div>
              <p className="cardboxtitle text-sm">
                {activeDevice?.status === "active"
                  ? "Your watch is synced"
                  : "Link your device with FastBetter"}{" "}
              </p>
              <p className="text-[11px]">
                {activeDevice?.status === "active"
                  ? "health stats are being synced, to change fo to settings."
                  : "Bring a new level of efficiency to your daily tasks. Your"}{" "}
              </p>
            </div>
          </div>
        </div>
        {menuOption.map((item, index) => {
          if (
            activeDevice &&
            activeDevice.health_device &&
            activeDevice.health_device === item.device &&
            activeDevice.status === "active"
          ) {
            item.isLinked = true;
          }
          return (
            <div
              key={item.key}
              className="cardbox w-full border border-gray-200 shadow-md py-3 px-3"
            >
              <div className="mode1">
                <img
                  className="watchImg w-20 h-20 rounded-md"
                  alt="watchImg"
                  src={item.src}
                />
                <div>
                  <p className="cardboxtitle text-sm">{item.name}</p>
                  <p className="text-[11px]">{item.subtitle}</p>
                  {item && item.isLinked ? (
                    <button
                      className="mt-2 !border-[0.2px] !border-[#FF5050] px-2 py-1.5 bg-[#ff505043] font-medium text-[#E94444] leading-none rounded-2xl text-[11px]"
                      onClick={() => {
                        //   handleLink(item.key);
                        handleUnLinkedDevice(item.device);
                      }}
                    >
                      Unlink {item.name}
                    </button>
                  ) : (
                    <button
                      className="mt-2 px-2 py-1.5 bg-[#ffede0] font-medium text-[#fe7701] leading-none rounded-2xl text-[11px]"
                      onClick={() => {
                        //   handleLink(item.key);
                        handleLinkedDevice(item.device);
                      }}
                    >
                      Click to link now
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <PopUpModel
        isPopupOpen={isPopupOpen}
        hanldeClose={hanldeClose}
        deviceKey={deviceKey}
      />
    </div>
  );
}

const PopUpModel = ({ isPopupOpen, hanldeClose, deviceKey }) => {
  const [deviceData, setDeviceData] = useState(null);
  const [islinked, setIslinked] = useState(false);
  const [nextProcessSuccess, setNextProcessSuccess] = useState(true);

  useEffect(() => {
    const selectedDevice = menuOptionData.find(
      (device) => device.key === deviceKey
    );
    setDeviceData(selectedDevice);
    setIslinked(selectedDevice?.isLinked);
  }, [deviceKey, menuOptionData]);

  const hanldeClickToAction = async () => {
    setNextProcessSuccess(false);
    if (!nextProcessSuccess && !islinked) {
      setNextProcessSuccess(true);
      setIslinked(true);
    }
  };

  return (
    <Popup
      open={isPopupOpen}
      position="center"
      className="pop-width-link"
      onClose={() => hanldeClose()}
    >
      <div className="w-32 h-32 -z-10 -top-2 right-36 absolute bg-white rounded-full "></div>
      <div className="text-center z-10 relative py-5 pb-8 px-5">
        {deviceData && (
          <div className="text-center">
            <img
              src={
                nextProcessSuccess
                  ? islinked
                    ? deviceData.src
                    : link
                  : errorlink
              }
              className="mx-auto mb-4"
              alt={deviceData.name}
            />
            <p className="!mb-2 text-2xl font-semibold">
              {nextProcessSuccess
                ? islinked
                  ? `Unlink ${deviceData.name} ?`
                  : `${deviceData.name} linked`
                : "Oops.. there is some issue"}
            </p>
            <p className="text-xs ">
              {
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
              }
            </p>
            <button
              onClick={hanldeClickToAction}
              className="bg-[#FF9950] text-white text-sm w-7/12 py-4 mt-6 rounded-2xl"
            >
              {nextProcessSuccess
                ? islinked
                  ? `Yes, unlink this device`
                  : `Start syncing`
                : "Try linking again"}
            </button>
          </div>
        )}
      </div>
    </Popup>
  );
};
